import SelectCustom from '@components/SelectCustom';

import { FieldRendererProps } from '../types';

const SelectField = ({ field }: FieldRendererProps) => {
  const options =
    field.options?.map((opt) => ({
      value: opt.value,
      label: opt.label,
    })) || [];

  return (
    <SelectCustom
      name={field.name}
      placeholder={field.placeholder || field.label}
      options={options}
      required={field.is_required}
    />
  );
};

export default SelectField;
